// @core/api/endpoints/secret/unseal.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SealStatusResponse,
  UnsealRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Submit unseal key
 * Submits a single unseal key share. When the threshold number of shares have been submitted, the service unseals and begins accepting operations. Returns updated seal status with progress.
 * @public This endpoint does not require authentication
 */
export async function Unseal(
  data: UnsealRequest,
  options?: RequestOptions
): Promise<SealStatusResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/sys/unseal`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<SealStatusResponse>(requestPath, data, requestOptions);
}
